import { ErrorOutline, KeyboardArrowDown } from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  InputBase,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import ErrorModal from "../modals/ErrorModal";
import SuccessModal from "../modals/SuccessModal";
import validator from "validator";
import { jwtDecode } from "jwt-decode";
import {
  formatPhoneNumber,
  formatPhoneNumberAsYouType,
} from "../utils/formatnumber";
import posthog from "posthog-js";
import decryptApi from "../utils/decryptApi";
import Front from "@frontapp/plugin-sdk";
import { useNavigate, useLocation } from "react-router-dom";

const Dailer = () => {
  async function decodeToken(token) {
    try {
      return await decryptApi(token);
    } catch (error) {
      console.error("Invalid token:", error);
      return null;
    }
  }

  const [call_data, setCallData] = useState({
    fromNumber: JSON.parse(localStorage.getItem("organization"))
      .twilio_integration?.M.primary_phone.S,
    forwarding_number: JSON.parse(
      localStorage.getItem("organization")
    ).channels?.L.filter((e) => e?.M.type.S === "forward_number")[0]?.M.value.S,
    recipient: "",
    account_sid: JSON.parse(localStorage.getItem("organization"))
      .twilio_integration.M.account_sid.S,
    api_key: JSON.parse(localStorage.getItem("organization")).twilio_integration
      .M.api_key.S,
  });

  let latestContext;

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const recipientParam = params.get('recipient');
    if (recipientParam) {
      setCallData((prev) => ({ ...prev, recipient: recipientParam }));
    }
  }, [location.search]);

  useEffect(()=> {
    const subscribe =  Front.contextUpdates.subscribe((context) => {
      latestContext = context
      let link
  
   latestContext.listMessages().then((response)=> {
    console.log({response})
    if(response.results.length > 0){
      const latestMessageIndex = response.results.length -1;
      let body = response.results[latestMessageIndex].content.body
      console.log({body})
     
  const path = body.match(/twilanswer\.com(\/[^\s"]+)/)?.[1];
  
  console.log({path});
  link = path
  
    }
  
    if (latestContext.entryPoint) {
      console.log(latestContext.entryPoint.type)
      if (
        latestContext.entryPoint &&
        latestContext.entryPoint.type == "CONTACT_HANDLE"
      ) {
        console.log("Front_phoner", latestContext.entryPoint.data.handle);
        setCallData({
          ...call_data,
          recipient: latestContext.entryPoint.data.handle,
        });
      }
  
      
    }
    
    
   })
  
    console.log(latestContext);
    });
    return()=>{
      subscribe.unsubscribe()
    }

  },[])

    


    

  const [err_msg, setErrorMsg] = useState(null);
  const [loader, setLoader] = useState(false);
  const [succeesModal, setSuccessModal] = useState(false);
  const [errorModal, setErrrorModal] = useState(false);
  const [from_numbers, setFromNumbers] = useState([]);

  async function getIncomingPhoneNumbers() {
    setLoader(true);
    setErrorMsg(null);
    let t = JSON.parse(localStorage.getItem("organization")).twilio_integration
      .M;
    console.log(t);
    await axios
      .post(
        process.env.REACT_APP_BACKEND_URL + "twilio/get-incoming-phone-numbers",

        {
          organization_id: JSON.parse(localStorage.getItem("organization"))
            .orgId.S,
          account_sid: t.account_sid.S,
          api_key: t.api_key.S,
          transcription_enabled: t.transcription_enabled.BOOL,
          test_account: t.test_account.BOOL,
          auto_configuration: t.auto_configuration.BOOL,
          primary_phone: t.primary_phone.S,
        }
      )
      .then((res) => {
        let data = res.data;
        if (res.data.length < 1) {
          setErrorMsg(
            "please add an incoming phone number in your twilio account"
          );
          setLoader(false);
        } else {
          if (t.test_account.BOOL) {
            setFromNumbers(
              data.filter((item) => item.phoneNumber === t.primary_phone.S)
            );
            console.log(
              data.filter((item) => item.phoneNumber === t.primary_phone.S)
            );
          } else {
            setFromNumbers(res.data);
            console.log("from_numbers", res.data);
          }
          console.log(res.data);
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.data) {
          console.error("Response data:", err.response.data);
          setErrorMsg(err.response.data.message);
        }
        setLoader(false);
      });
  }

  useEffect(() => {
    getIncomingPhoneNumbers();
  }, []);

  const call = async () => {
    let check = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,
      {
        userId: JSON.parse(localStorage.getItem("user")).userId.S,
      }
    );

    if (check.status === 200) {
      const user___ = check.data.user;

      if (
        user___.relatedOrgs.L?.find(
          (e) =>
            e?.M.org_id?.S ===
            JSON.parse(localStorage.getItem("organization")).orgId.S
        )
      ) {
        if (validator.isMobilePhone(call_data.recipient)) {
          try {
            setLoader(true);
            console.log(call_data);

            let twilio_call = await axios.post(
              process.env.REACT_APP_BACKEND_URL + "twilio/create-call",
              call_data
            );
            console.log(twilio_call);
            let call_data_ = twilio_call.data.call;

            let call_ = await axios.post(
              process.env.REACT_APP_BACKEND_URL + "call/create-call",
              {
                organizationId: JSON.parse(localStorage.getItem("organization"))
                  .orgId.S,
                startTime: Date.now(),
                toNumber: call_data.recipient, //rather than call_data_.to
                fromNumber: call_data_.from,
                action: "Outbound Call",
                action_details: call_data.forwarding_number,
                has_vm: false,
                // route:'rte_1736034904361_4479858e'
              }
            );

            setSuccessModal(true);
            posthog.capture("Dailed a phone call", {
              email: JSON.parse(localStorage.getItem("user")).email.S,
              userId: JSON.parse(localStorage.getItem("user")).userId.S,
            });
            setLoader(false);
          } catch (error) {
            console.log(error);
            setErrrorModal(true);
            if (error.response && error.response.data) {
              console.error("Response data:", error.response.data);
              setErrorMsg(
                error.response.data.error + " " + error.response.data?.message
              );
            }
            setLoader(false);
          }
        } else {
          setErrorMsg("Recipient number is not valid");
          setErrrorModal(true);
        }
      } else {
        window.location.reload();
      }
    }
  };
  const handleNavigation = (to) => {
    window.location.assign(to);
  };

  return (
    <div className="pt-7 px-4">
      <div className="lg:text-[17px] text-[15px] font-semibold">Dialer</div>

      <SuccessModal
        open={succeesModal}
        setOpen={setSuccessModal}
        call_data={call_data}
        setCallData={setCallData}
        decodeToken={decodeToken}
      />

      <ErrorModal
        open={errorModal}
        setOpen={setErrrorModal}
        call_data={call_data}
        setCallData={setCallData}
        err_msg={err_msg}
        setErrorMsg={setErrorMsg}
        decodeToken={decodeToken}
      />

      <div className="bg-white rounded-[13px]  w-full my-5 px-12 py-5 flex justify-center ">
        <div className="space-y-5">
          <div className="lg:flex justify-end items-center lg:space-x-10 ">
            <div className="lg:text-[16px] text-[14px] font-bold flex items-center">
              From Number
              <Tooltip
                title="The number you would like to display as the caller ID to your recipient."
                arrow
              >
                <img src="/icons/tooltip.png" className="w-[15px] lg:ml-3 " />
              </Tooltip>
            </div>

            <div className="w-[200px]">
              <Select
                IconComponent={KeyboardArrowDown}
                fullWidth
                value={call_data.fromNumber}
                onChange={(e) => {
                  setCallData({
                    ...call_data,
                    fromNumber: e.target.value,
                  });
                }}
                className="mb-2 bg-[#FAFAFB]"
                sx={{
                  fontSize: "14px",
                  padding: "4px 8px", // Adjust padding here
                  "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                  "& .MuiSelect-select": {
                    padding: "4px 8px", // Adjust padding for the text inside Select
                  },
                }}
              >
                {from_numbers &&
                  from_numbers.map((item, index) => (
                    <MenuItem value={item.phoneNumber}>
                      {formatPhoneNumber(item.phoneNumber)}
                    </MenuItem>
                  ))}
                {/* <MenuItem value={call_data.fromNumber}>
                  {formatPhoneNumber(call_data.fromNumber)}
                </MenuItem> */}
              </Select>
            </div>
          </div>
          <div className="lg:flex justify-end items-center lg:space-x-10 ">
            <div className="lg:text-[16px] text-[14px] font-bold flex items-center">
              Forwarding Number{" "}
              <Tooltip
                title="The number you would like to use to make the call. We will call you first, then connect you to your recipient."
                arrow
              >
                <img src="/icons/tooltip.png" className="w-[15px] lg:ml-3 " />
              </Tooltip>
            </div>

            <div className="w-[200px]">
              <Select
                IconComponent={KeyboardArrowDown}
                fullWidth
                defaultValue="Forward w/ VM"
                value={call_data.forwarding_number}
                onChange={(e) => {
                  setCallData({
                    ...call_data,
                    forwarding_number: e.target.value,
                  });
                }}
                className="mb-2 bg-[#FAFAFB]"
                sx={{
                  fontSize: "14px",
                  padding: "4px 8px", // Adjust padding here
                  "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                  "& .MuiSelect-select": {
                    padding: "4px 8px", // Adjust padding for the text inside Select
                  },
                }}
              >
                {JSON.parse(localStorage.getItem("organization"))
                  .channels?.L.filter((e) => e.M.type.S === "forward_number")
                  .map((item, index) => {
                    return (
                      <MenuItem value={item.M.value.S}>
                        {formatPhoneNumber(item.M.value.S)}
                      </MenuItem>
                    );
                  })}

                <MenuItem
                  sx={{
                    textAlign: "center",
                    textTransform: "none",
                    bgcolor: "white",
                    color: "#605BFF",
                    px: "2px",
                    borderRadius: "7px",
                    fontSize: { lg: "14px", xs: "13px" },
                    width: "100%",
                  }}
                  onClick={() => {
                    handleNavigation(
                      "/dashboard/channels?channeltype=forward_number"
                    );
                  }}
                >
                  <div className="text-center w-full"> Add Phone Number</div>
                </MenuItem>
              </Select>
            </div>
          </div>
          <div className="lg:flex justify-end items-center lg:space-x-10 ">
            <div className="lg:text-[16px] text-[14px] font-bold flex items-center">
              Recipient{" "}
              <Tooltip title="The number you would like to call." arrow>
                <img src="/icons/tooltip.png" className="w-[15px] lg:ml-3 " />
              </Tooltip>
            </div>

            <div className="w-[200px]">
              <InputBase
                value={call_data.recipient}
                onChange={(e) => {
                  setCallData({
                    ...call_data,
                    recipient: formatPhoneNumberAsYouType(e.target.value),
                  });
                }}
                sx={{
                  bgcolor: "#F7F7F8",
                  width: "100%",
                  px: 2,
                  py: "2px",
                  fontSize: "14px",
                }}
              />
            </div>
          </div>

          <div className="flex justify-center pt-6 pb-4">
            <Button
              sx={{
                textTransform: "none",
                bgcolor: "#605BFF",
                color: "white",
                py: "4px",
                px: "40px",
                borderRadius: "7px",
                fontSize: { lg: "17px", xs: "14px" },
              }}
              onClick={!loader && call}
              //disabled={ ! (/^\(\d{3}\) \d{3}-\d{4}$/.test(call_data.recipient))}
              disabled={call_data?.recipient?.length <= 1}
            >
              {loader ? (
                <CircularProgress
                  size={"1.2rem"}
                  sx={{ color: "white", animationDuration: "0.7s" }}
                />
              ) : (
                <>
                  <img
                    src="/icons/phone_white.png"
                    className="lg:w-[20px] w-[15px]  mr-2"
                  />
                  Call
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dailer;
